<template>
  <div class="dushu-index-wrapper">
    <div class="tips">
      <div class="tips-animation">
        <div class="tips-text">数据后台每小时刷新，会造成部分数据最多延时显示1小时。如需实时获取订单信息，请打开订单信息实时推送功能。</div>
        <div class="tips-text">数据后台每小时刷新，会造成部分数据最多延时显示1小时。如需实时获取订单信息，请打开订单信息实时推送功能。</div>
      </div>
    </div>
    <template v-if="menuItems[0].active">
      <ul class="data-list">
        <li class="data-item">
          <span class="title">昨日数据</span>
          <span class="data price">{{lastDayAmount}}</span>
        </li>
        <li class="data-item">
          <span class="title">历史总金额</span>
          <span class="data price total">{{amount}}</span>
        </li>
        <li class="data-item">
          <span class="title">付费用户数</span>
          <span class="data user">{{paidUserCount}}</span>
        </li>
      </ul>

      <ul class="date-list center mt10">
        <li :class="['date-item', chartType === 'income' ? 'active' : '']" @click="onChangeChartType('income')">收入</li>
        <li :class="['date-item', chartType === 'follow' ? 'active' : '']" @click="onChangeChartType('follow')">关注人数</li>
      </ul>

      <ve-line :data="chartType === 'income' ? chartData : chartDataFollow" :extend="extend" :colors="['#e51c23', '#ffe5c8', '#e2efd3']" :legend="{show: dateType === 'hour'}"></ve-line>

      <ul class="date-list">
        <div :class="['date-select', 'select-wrapper', dateType === 'hour' ? '' : 'disabled']" v-if="dateType === 'hour'">
          <select @change="onChangeStatisticDay">
            <option v-for="day in statisticDays" :value="day" :selected="day === selectedStatisticDay">{{day}}</option>
          </select>
          <span class="select-label">{{selectedStatisticDay}}</span>
        </div>

        <li :class="['date-item', dateType === 'hour' ? 'active' : '']" @click="onChangeDateType('hour')">小时</li>
        <li :class="['date-item', dateType === 'day' ? 'active' : '']" @click="onChangeDateType('day')">天</li>
        <li :class="['date-item', dateType === 'week' ? 'active' : '']" @click="onChangeDateType('week')">周</li>
        <li :class="['date-item', dateType === 'month' ? 'active' : '']" @click="onChangeDateType('month')">月</li>
      </ul>

      <Table :data="tableStatistics" />
    </template>

    <template v-if="menuItems[1].active">
      <!-- <v-select class="select-item" v-model="selectedDate" :options="dates" :clearable="false" /> -->
      <div class="top-wrapper">
        <div class="select-wrapper">
          <select @change="onChangeDate">
            <option v-for="date in dates" :value="date.value">{{date.label}}</option>
          </select>
          <span class="select-label">{{selectedDate.label}}</span>
        </div>

        <div class="radio-wrapper">
          订单信息实时推送
          <i :class="['radio', enablePaymentNotify ? 'active' : '']" @click="onChangePaymentNotify" />
          {{enablePaymentNotify ? '开' : '关'}}
        </div>
      </div>

      <ve-pie :series="[{
        type: 'pie',
        radius : '40%',
        center: ['30%', '50%'],
        label: false,
        data: chartPieData.rows,
      }]" :legend="{type: 'scroll', orient: 'vertical', top: 'center', right: 10}" :tooltip="{formatter: '{b}<br/>用户数: {c}'}" height="300px" />

      <div class="total-tip">共<i>{{tableOrders.body.length}}</i>条记录</div>
      <Table :data="tableOrders" />
    </template>

    <template v-if="menuItems[2].active">
      <ul class="data-list center">
        <li class="data-item">
          <span class="title">昨日新增</span>
          <span class="data user red">{{users.lastDayIncr}}</span>
        </li>
        <li class="data-item">
          <span class="title">总用户数</span>
          <span class="data user">{{users.total}}</span>
        </li>
      </ul>

      <div class="select-wrapper-list">
        <div class="select-wrapper">
          <select @change="onChangeUserParamsVip">
            <option v-for="item in Object.keys(selectMap.vip)" :selected="item === userParams.isVip" :value="item">{{selectMap.vip[item]}}</option>
          </select>
          <span class="select-label">{{selectMap.vip[userParams.isVip]}}</span>
        </div>
        <div class="select-wrapper">
          <select @change="onChangeUserParamsGender">
            <option v-for="item in Object.keys(selectMap.gender)" :selected="item === userParams.gender" :value="item">{{selectMap.gender[item]}}</option>
          </select>
          <span class="select-label">{{selectMap.gender[userParams.gender]}}</span>
        </div>
      </div>

      <div class="total-tip">共<i>{{paginationData.total}}</i>条记录</div>
      <Table class="user-info-table" :data="users" />
      <div class="pagination-wrapper">
        <pagination class="justify-content-end" :data="paginationData" @pagination-change-page="onPageChange" :limit="1" />
      </div>
    </template>

    <template  v-if="menuItems[3] && menuItems[3].active">
      <SettlementPanel
        :key="(settleAccount || {}).bankAccountId"
        :totalAmount="totalAmount"
        :settleAccount="settleAccount"
        :settleAccounts="settleAccounts"
        :reportUrls="reportUrls"
        @on-select-account="onChangeAccount"
      />
    </template>

    <i class="data-loading" v-if="isLoading">数据加载中...</i>
    <Menu class="fixed-menu" :items="menuItems" @on-change-menu="onChangeMenu" />

    <SwitchProvider />
  </div>
</template>

<script>
import moment from 'moment'

import VeLine from 'v-charts/lib/line.common'
import VePie from 'v-charts/lib/pie.common'
import 'echarts/lib/component/legendScroll'
import SettlementPanel from './Settlement.vue';

import Menu from '@/components/dushu/Menu.vue'
import Table from '@/components/dushu/Table.vue'
import SwitchProvider from '@/components/dushu/SwitchProvider.vue'

import Dushu from '@/engine/Dushu'
import Settlement from '@/engine/Settlement'

import chartsPng from '@/assets/dushu/charts.png'
import chartsActivePng from '@/assets/dushu/charts_active.png'
import detailPng from '@/assets/dushu/detail.png'
import detailActivePng from '@/assets/dushu/detail_active.png'
import groupPng from '@/assets/dushu/group.png'
import groupActivePng from '@/assets/dushu/group_active.png'
import walletPng from '@/assets/dushu/wallet.png'
import walletActivePng from '@/assets/dushu/wallet_active.png'

const state = {
  channelMap: {},
  channels: {},
  users: {},
}

const formatRecentStatisticsData = (vm, data, key) => {
  const dataObject = {}
  const newData = []
  data.forEach((item) => {
    dataObject[parseInt(item.dateHour)] = item
  })
  new Array(24).fill(1).forEach((i, index) => {
    newData.push(dataObject[index] || {
      amountPayment: '0',
      cntOrders: '0',
      cntPayment: '0',
      cntSubscribed: '0',
      dateDay: '',
      dateHour: index,
      dateMonth: '',
      dateWeek: ''
    })
  })
  data = newData

  data.forEach((item, index) => {
    vm.chartData.rows[index][key] = parseInt(item.amountPayment / 100)
    vm.chartDataFollow.rows[index][key] = item.cntSubscribed
  })
}

const formatRecentStatistics = (vm) => {
  Dushu.partnerGetStatistics(vm.dateType, moment(vm.selectedStatisticDay).subtract(1, 'd').format('YYYY-MM-DD')).then(({ data }) => {
    formatRecentStatisticsData(vm, data, '昨日')
  })
  Dushu.partnerGetStatistics(vm.dateType, moment(vm.selectedStatisticDay).subtract(7, 'd').format('YYYY-MM-DD')).then(({ data }) => {
    formatRecentStatisticsData(vm, data, '7天前')
  })
}

const formatStatistics = (vm) => {
  vm.isLoading = true
  vm.chartData.columns = vm.dateType === 'hour' ? ['日期', '今日金额', '昨日', '7天前'] : ['日期', '今日金额']
  vm.chartDataFollow.columns = vm.dateType === 'hour' ? ['日期', '今日关注人数', '昨日', '7天前'] : ['日期', '今日关注人数']
  vm.tableStatistics.head[0] = vm.dateType === 'hour' ? '时间段' : '日期'

  Dushu.partnerGetStatistics(vm.dateType, vm.selectedStatisticDay).then(({ data }) => {
    const statistics = []
    let isNeedUpdate = false
    if (vm.dateType === 'day' && !vm.statisticDays.length) {
      vm.statisticDays = []
      isNeedUpdate = true
    }

    data.sort((firstEl, secondEl) => {
      return parseInt(`${secondEl.dateYear}${secondEl.dateWeek.length === 1 ? '0' + secondEl.dateWeek : secondEl.dateWeek}`, 10) - parseInt(`${firstEl.dateYear}${firstEl.dateWeek.length === 1 ? '0' + firstEl.dateWeek : firstEl.dateWeek}`, 10)
    })
    data.forEach((item) => {
      if (isNeedUpdate) {
        vm.statisticDays.push(item.dateDay)
      }
      const className = []
      if (moment(item.dateDay).date() === 1) {
        className.push('month')
      }
      if (moment(item.dateDay).day() === 1) {
        className.push('week')
      }

      statistics.push({
        className,
        data: [
          item.dateDay || item.dateMonth || (item.dateWeek ? `${item.dateYear}第${item.dateWeek}周` : '') || (item.dateHour ? `${item.dateHour}:00~${parseInt(item.dateHour, 10) + 1}:00` : ''),
          item.cntSubscribed,
          // item.cntUnsubscribed,
          item.cntOrders,
          item.cntPayment,
          parseInt(item.amountPayment / 100)
        ]
      })
    })
    vm.tableStatistics.body = statistics

    if (vm.dateType === 'hour') {
      formatRecentStatistics(vm)
      const dataObject = {}
      const newData = []
      data.forEach((item) => {
        dataObject[parseInt(item.dateHour)] = item
      })
      new Array(24).fill(1).forEach((i, index) => {
        const newIndex = 23 - index
        newData.push(dataObject[newIndex] || {
          amountPayment: '0',
          cntOrders: '0',
          cntPayment: '0',
          cntSubscribed: '0',
          dateDay: '',
          dateHour: newIndex,
          dateMonth: '',
          dateWeek: ''
        })
      })
      data = newData
    }

    vm.chartData.rows = data.reverse().map((item) => {
      return {
        '日期': item.dateDay || item.dateMonth || (item.dateWeek ? `${item.dateYear}第${item.dateWeek}周` : '') || (item.dateHour ? `${item.dateHour}:00~${parseInt(item.dateHour, 10) + 1}:00` : ''),
        '今日金额': parseInt(item.amountPayment / 100),
        '昨日': '',
        '7天前': '',
      }
    })
    vm.chartDataFollow.rows = data.map((item) => {
      return {
        '日期': item.dateDay || item.dateMonth || (item.dateWeek ? `${item.dateYear}第${item.dateWeek}周` : '') || (item.dateHour ? `${item.dateHour}:00~${parseInt(item.dateHour, 10) + 1}:00` : ''),
        '今日关注人数': item.cntSubscribed,
        '昨日': '',
        '7天前': '',
      }
    })
    if (isNeedUpdate) {
      vm.selectedStatisticDay = vm.statisticDays[0]
    }

    vm.isLoading = false
  })
}

const formatOrders = (vm) => {
  vm.isLoading = true
  Dushu.partnerGetOrders(vm.selectedDate.value).then(({ data }) => {
    vm.tableOrders.body = data.map(({ date, nickname, amount, channel }) => {
      const displayChannel = state.channelMap[channel] || channel || '其他'
      if (!state.channels[displayChannel]) {
        state.channels[displayChannel] = 0
      }
      state.channels[displayChannel] += 1

      return [
        date.substring(0, 10),
        date.substring(11, 19),
        nickname,
        parseInt(amount / 100),
        displayChannel,
      ]
    })

    vm.chartPieData.rows = Object.keys(state.channels).filter((item) => {
      return !!state.channels[item]
    }).map((item) => {
      return {
        name: `${item}: ${(state.channels[item] * 100 / data.length).toFixed(2)}%`,
        value: state.channels[item],
      }
    }).sort((itemA, itemB) => {
      if (itemA.value > itemB.value) {
        return -1
      }
      if (itemA.value < itemB.value) {
        return 1
      }
      return 0
    })

    vm.isLoading = false
  })
}

const fetchUsers = (vm) => {
  vm.isLoading = true
  const pageSize = 100
  const isVip = vm.userParams.isVip === 'all' ? undefined : vm.userParams.isVip
  const gender = vm.userParams.gender === 'all' ? undefined : vm.userParams.gender

  Dushu.partnerListUsers(gender, isVip, pageSize, vm.paginationData['current_page']).then(({ data, lastDayIncr, total }) => {
    vm.users.lastDayIncr = lastDayIncr
    vm.users.total = total
    state.users = {}
    vm.users.body = data.map(({ nickname, gender, country, city, province, groupsCount, isRobotFriend, subscribed, isVip }) => {
      return [
        nickname,
        vm.selectMap.gender[gender],
        province || city || country,
        // groupsCount,
        isRobotFriend ? {html: '<span class="red">是</span>'} : '否',
        subscribed ? {html: '<span class="red">是</span>'} : '否',
        isVip ? {html: '<span class="red">是</span>'} : '否'
      ]
    // }).forEach((item, index) =>{
    //   const pageIndex = parseInt(index / pageSize, 10) + 1
    //   if (!state.users[pageIndex]) {
    //     state.users[pageIndex] = []
    //   }
    //   state.users[pageIndex].push(item)
    })
    vm.paginationData.total = total
    // vm.paginationData['current_page'] = 1
    vm.paginationData['last_page'] = parseInt((total - 1) / pageSize, 10) + 1
    // vm.users.body = state.users[1]
    vm.isLoading = false
  })
}

const partnerGetAvailableOrderDate = (vm) => {
  vm.isLoading = true
  Dushu.partnerGetAvailableOrderDate().then(({ data }) => {
    vm.dates = [{
      label: '全部',
      value: '',
    }, ...data.map((item) => {
      return {
        label: item ? item.substring(0, 10) : '',
        value: item,
      }
    })]
    if (data && data.length) {
      vm.selectedDate = vm.dates[0]
      formatOrders(vm)
    }
  })
}

const initSettlement = (vm) => {
  Settlement.fetchBaseInfo().then(({accounts, totalAmount}) => {
    const settleAccounts = accounts.filter(({ userInfos }) => { return userInfos && userInfos.length; })
      .map((account) => {
        return {
          ...account,
          autoWithdrawTime: moment(account.autoWithdrawTime),
          autoWithdrawLimit: +(account.autoWithdrawLimit / 100).toFixed(2),
        };
      });

    const settleAccount = settleAccounts.find((account) => { return account.bankAccountId === vm.bankAccountId; }) || settleAccounts[0];

    vm.totalAmount = +totalAmount;
    vm.settleAccounts = settleAccounts;
    vm.settleAccount = settleAccount || {};
    vm.bankAccountId = vm.settleAccount.bankAccountId;
  });

  Settlement.fetchReport().then(({ urls }) => {
    vm.reportUrls = urls;
  })
}

export default {
  name: 'dushuIndex',
  components: {
    VeLine,
    VePie,
    Menu,
    Table,
    SettlementPanel,
    SwitchProvider,
  },
  data () {
    return {
      amount: '',
      lastDayAmount: '',
      paidUserCount: '',
      dateType: 'day',
      chartType: 'income',
      selectedDate: '',
      dates: [],
      enablePaymentNotify: false,
      isLoading: false,
      statisticDays: [],
      selectedStatisticDay: '',
      paginationData: {
        "total": 0,
        "per_page": 100,
        "current_page": 1,
        "last_page": 0,
      },
      menuItems: [{
        id: 1,
        name: '数据汇总',
        active: true,
        icon: chartsPng,
        iconActive: chartsActivePng,
      }, {
        id: 2,
        name: '订单明细',
        active: false,
        icon: detailPng,
        iconActive: detailActivePng,
      }, {
        id: 3,
        name: '用户列表',
        active: false,
        icon: groupPng,
        iconActive: groupActivePng,
      }],
      tableStatistics: {
        head: ['日期', '关注', '订单', '付款', '金额'],
        body: [],
      },
      tableOrders: {
        head: ['日期', '时间', '用户昵称', '金额', '渠道'],
        body: [],
      },
      chartData: {
        columns: ['日期', '今日金额', '昨日', '7天前'],
        rows: []
      },
      chartDataFollow: {
        columns: ['日期', '今日关注人数', '昨日', '7天前'],
        rows: []
      },
      chartPieData: {
        columns: ['渠道', '用户数'],
        rows: []
      },
      extend: {
        series: {
          smooth: false
        }
      },
      selectMap: {
        vip: {
          all: '所有用户',
          true: '付费用户',
          false: '非付费用户',
        },
        gender: {
          all: '所有性别',
          0: '未知',
          1: '男',
          2: '女',
        }
      },
      userParams: {
        isVip: 'all',
        gender: 'all',
      },
      users: {
        lastDayIncr: '',
        total: '',
        head: ['用户昵称', '性别', '地域', '个号', '关注', '付费'],
        body: [],
      }
    }
  },
  async mounted () {
    this.isLoading = true
    Dushu.partnerGetSummary().then(({ amount, lastDayAmount, paidUserCount }) => {
      this.amount = amount ? parseInt(amount / 100) : ''
      this.lastDayAmount = lastDayAmount ? parseInt(lastDayAmount / 100) : ''
      this.paidUserCount = paidUserCount
    })

    const { items } = await Dushu.listShareTypeMetas();
    (items || []).forEach((item) => {
      state.channelMap[item.shareType] = item.name
      state.channels[item.name] = 0
    })

    const { enableWithdraw } = this.globalData.settings || {};
    if (enableWithdraw) {
      initSettlement(this)
      this.menuItems.push({
        id: 4,
        name: '自助提现',
        active: false,
        icon: walletPng,
        iconActive: walletActivePng,
      });
    }
    formatStatistics(this)
    this.enablePaymentNotify = !!(this.globalData.settings && this.globalData.settings.enablePaymentNotify)
  },
  methods: {
    onChangeMenu: function (activeId) {
      if (activeId === 2 && !this.dates.length) {
        partnerGetAvailableOrderDate(this)
      }
      if (activeId === 3 && !state.users[1]) {
        fetchUsers(this)
      }
      // if (activeId === 4) {
      //   initSettlement(this);
      // }

      this.menuItems = this.menuItems.map((item) => {
        return {
          ...item,
          active: item.id === activeId,
        }
      })
    },
    onChangeDateType: function (dateType) {
      this.dateType = dateType
      formatStatistics(this)
    },
    onChangeChartType: function (chartType) {
      this.chartType = chartType
    },
    onChangeDate: function (event) {
      const date = event.target.value
      this.selectedDate = {
        label: date ? date.substring(0, 10) : '全部',
        value: date,
      }
      state.channels = {}
      Object.keys(state.channelMap).forEach((item) => {
        state.channels[state.channelMap[item]] = 0
      })
      formatOrders(this)
    },
    onChangeUserParamsVip: function (event) {
      const value = event.target.value
      this.userParams.isVip = value

      // this.$toast('loading...')
      this.paginationData['current_page'] = 1
      fetchUsers(this)
    },
    onChangeUserParamsGender: function (event) {
      const value = event.target.value
      this.userParams.gender = value

      // this.$toast('loading...')
      this.paginationData['current_page'] = 1
      fetchUsers(this)
    },
    onChangePaymentNotify: function () {
      this.enablePaymentNotify = !this.enablePaymentNotify
      Dushu.partnerUpdateSetting(this.enablePaymentNotify)
    },
    onPageChange: function (page) {
      this.paginationData['current_page'] = page
      // this.users.body = state.users[page]
      fetchUsers(this)
    },
    onChangeStatisticDay: function (event) {
      if (this.dateType !== 'hour') {
        return
      }
      const value = event.target.value
      this.selectedStatisticDay = value

      formatStatistics(this)
    },
    onChangeAccount: function (account) {
      this.settleAccount = account;
    }
  },
};
</script>

<style src="./index.scss" lang="scss"></style>
